var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"nian-du-wang-luo-ling-shou"},[_c('PageBlock',{attrs:{"title":"区域概览"}},[_c('div',{staticClass:"content"},[_c('div',{staticStyle:{"text-align":"center","color":"#fff","font-size":"14px","line-height":"28px"}},[_vm._v("网络零售趋势图")]),_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"260px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }